import React from 'react'
import PropTypes from 'prop-types'
import {Text, Flex, Alert} from '@chakra-ui/react'
import WarningIcon from '../icons/WarningIcon'
import InfoIcon from '../icons/others/InfoIcon'
import {remCalc} from '../../theme/_utils'

export const AlertMessage = ({status, title, description}) => {
    let icon

    const getStatus = () => {
        switch (status) {
            case 'info':
                icon = <InfoIcon />
                return
            case 'warning':
                icon = <WarningIcon />
                return
            default:
                return null
        }
    }

    getStatus()

    return (
        <Alert
            status={status}
            backgroundColor="background.light-blue"
            borderColor="border.light"
            borderStyle={'solid'}
            p={remCalc(26)}
        >
            <Flex gap={remCalc(17)}>
                {icon}
                <Flex direction="column" alignItems="flex-start" justifyContent={'center'}>
                    {title && status === 'warning' && (
                        <Text fontWeight="bold" textStyle={'body-small'}>
                            {title}
                        </Text>
                    )}
                    <Text textStyle={'body-small'}>{description}</Text>
                </Flex>
            </Flex>
        </Alert>
    )
}
AlertMessage.propTypes = {
    status: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
}
